export default __webpack_public_path__ + "330e879afe4a0abb35f235e29be3084f.ttf";